import { MediaImageQrCode } from 'editor/src/store/design/types';
import { getQrCodeSourceTextUuids } from 'editor/src/store/design/util/qrSourceTexts';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import updateHiddenElementsOperation from './updateHiddenElementsOperation';

/**
 * Re-derives the hidden state of every spread holding a text a QR read before or reads
 * now, after its config changed or it was removed. The texts can sit on another spread
 * than the QR, such as the other side of a card.
 */
const refreshQrSourceTextsOperation =
  (before: MediaImageQrCode | undefined, after: MediaImageQrCode | undefined) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const formerTexts = getQrCodeSourceTextUuids(before);
    const nextTexts = getQrCodeSourceTextUuids(after);
    if (formerTexts.size === nextTexts.size && [...formerTexts].every((uuid) => nextTexts.has(uuid))) {
      return;
    }

    getState().design.designData?.spreads.forEach((spread, spreadIndex) => {
      const holdsOne = spread.pages.some((page) =>
        page.groups.media?.some(({ uuid }) => formerTexts.has(uuid) || nextTexts.has(uuid)),
      );
      if (holdsOne) {
        dispatch(updateHiddenElementsOperation(spreadIndex, formerTexts));
      }
    });
  };

export default refreshQrSourceTextsOperation;
